<section class="sa-card-container" aria-label="standing authorization selector" *ngIf="authorizationCount > 0">
  <header class="sa-card-container__header">
    <h3 class="sa-card-container__title">{{ label }}</h3>
    <span class="sa-card-container__count" data-testid="sa-count">
      <span class="sa-card-container__count-icon" role="img" aria-hidden="true"></span>
      {{ authorizationCount }} {{ templatesCountMessage }}
    </span>
  </header>

  <div class="sa-card-container__cards" role="list">
    <button
      *ngFor="let card of cards"
      type="button"
      class="sa-card"
      [class.sa-card--selected]="card.selected"
      [class.sa-card--disabled]="disabled"
      [disabled]="disabled"
      (click)="onSelectCard(card.id)"
      [attr.aria-pressed]="card.selected"
      [attr.data-testid]="'sa-card-' + card.id"
    >
      <div class="sa-card__header-row">
        <span class="sa-card__title">{{ card.title }}</span>
        <span *ngIf="card.selected" class="sa-card__check" aria-hidden="true"></span>
      </div>
      <div *ngIf="card.subtitle" class="sa-card__subtitle">{{ card.subtitle }}</div>
      <div *ngFor="let detail of card.details" class="sa-card__detail">{{ detail }}</div>
    </button>
  </div>
</section>
